import { Schema } from '@core/data/dto/schema';
import { getLocalMomentFromUtc } from '@core/utils/date-time';
import { FORMAT } from '@core/utils/formats';

export const DeliveryOrderRefundSchema = {
    status: Schema.String,
    dsp_approved_at: {
        map: 'dspApprovedAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER)
    },
    dsp_approved_amount: Schema.Number,
    request_at: {
        map: 'requestAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    refund_note: Schema.String,
    resolved_at: {
        map: 'resolvedAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    requesterId: Schema.String,
    refund_amount: Schema.Number,
    reject_reason: Schema.String,
    requester_name: Schema.String,
    support_note: Schema.String
};
